export default __webpack_public_path__ + "static/media/slide_02.400aabe7.png";